import { Link } from 'react-router-dom';
import { FaRegChartBar } from 'react-icons/fa';

const ReportCard = props => {
  return (
    <Link className="card shadow-sm border-0 col-md-4" to={`/reports/${props.id}`}>
      <div className="card-body p-3">
        <div className="d-flex align-items-center">
          <div>
            <FaRegChartBar size={44} color="#ccc" />
          </div>

          <div className="ms-4">
            <h6 className="m-0 text-primary">{props.name}</h6>
            <p className="m-0 text-dark">{props.description}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ReportCard;
